<template>
<div  class="container-fluid" >
<printZebraModal :key="refresh" v-bind:data='sample'></printZebraModal>  

<div class="card border-primary ">
    <div class="card-header bg-primary text-white">  
      
        <h4>
           <i class="fas fa-label  mr-2" aria-hidden="true"></i>
          LAYOUT ETICHETTA</h4>
    </div>
    <div class="card-body"> 
   
        <div>
    <div class="form-group">
    <label  for="categoria"><strong>Etichetta</strong></label>
        <select @change="setData(labelId)"   class="form-control" v-model="labelId">
                
        <option v-for="(option,index) in labels" :key="index" :value="option.label_Id">
            {{ option.description  }}
        </option>
        
        </select> 
    </div>
    </div>

    <div class="table-responsive">
       <table  class="table table-hover table-fixed table-sm mb-4" id="table">
        <thead >
        <tr>
          <th># </th>   
          <th>ITEM</th>   
          <th class="w-50">ZPL</th>   
          <th>SKIP</th>   
          <th>FMT</th>   
          <th>BLANK</th>   
          <th>LENGTH</th>   
          <th ></th>
        </tr>
        </thead>
        <tbody >
        
        <tr   @dblclick.ctrl="openItem(index)"  data-toggle="tooltip" title="doppio click modifica layout" :class="`index-${index}`" v-for="(item, index)  in items" :key="index">
          
          <td>{{index+1}}</td> 

          <td>{{item.fd_key}}
          
          </td> 
          
          
          <td  class="">
            <span  v-if="!isOpen[index]">
              {{item.zpl}}
            </span>
                        
            <input v-focus  v-else v-model = "item.zpl" class="form-control bold"  v-bind:id="'id_' + index " type="text">
            
          </td>
          
          <td v-if="!isOpen[index]">{{item.skip}}</td> 
          <td v-else>
            <input  v-model = "item.skip" min="0" max="1" class="form-control bold"  v-bind:id="'id_' + index " type="number"> 
          </td> 

          <td v-if="!isOpen[index]">{{item.fmt}}</td> 
          <td v-else>
            <input min="0" max="1" v-model = "item.fmt" class="form-control bold"  v-bind:id="'id_' + index " type="number"> 
          </td> 

          <td v-if="!isOpen[index]">{{item.blank}}</td> 
          <td v-else>
            <input min="0" max="1" v-model = "item.blank" class="form-control bold"  v-bind:id="'id_' + index " type="number"> 
          </td> 

          <td v-if="!isOpen[index]">{{item.fd_len}}</td>
          <td v-else>
            <input  v-model = "item.fd_len" class="form-control bold"  v-bind:id="'id_' + index " type="number"> 
          </td> 

          
          <td v-if="isOpen[index]">
            <button @click="updateData(item)" type="button"  class="btn btn-primary ">
              <i class="fas fa-save mr-2" aria-hidden="true"></i>
              SALVA
            </button>  
          </td>
          
          
        </tr>

        
        </tbody>
      </table>
    </div>

   
    
   
   
   
    <alert-box class="mt-4" @close="msg.title=''" v-bind:msg="msg"  ></alert-box> 

    <!--<strong>Filtra colore</strong> <input class="form-control" type="text"  v-model="filterKey">  -->
  
    
    </div>




 <div class="card-footer">
  <div  class="mt-1">        
  
      <button :hidden="true" @click="printTest()" :disabled="items.length==0" type="button"  class="btn btn-success mb-2">
         <i class="fas fa-print mr-2" aria-hidden="true"></i>
        STAMPA ETICHETTA DI PROVA</button>  
  </div>
  <div >

  </div> 


  
  </div>

</div>
  


</div>    
</template>
<script>
import { mapGetters }    from 'vuex';

import api               from '@/api'
import alertBox          from '@/components/common/AlertBox.vue'
import printZebraModal    from '@/components/common/PrintZebraModal.vue';


export default {
  components: {alertBox,printZebraModal},
  props: [''],
  data () {
    return {

       

        spinner         : false,
        
        labelId         : '',
        labels          : [],
        items           : [],
        layout          : [],
        update          : false,
        refresh         : 0,
        isOpen          : [],
        
      
        sample          : [{'brand':'BRAND TEST',
        'barcode':'3129424000148',
        'category':'JEANS TEST',
        'sku':'TEST XXX 1111 00000000',
        'description' : 'JEANS CON STRAPPI ',
        'size':'XXL','color':'FANTASIA','qty':1,'retailPrice':'1000.00'}],
        
        
        
        msg             : {title : '',body:'',type :0},
        
    }
  },
  directives: {
    focus: {
      // directive definition
      inserted: function(el) {
        el.focus();
      }
    }
  },  
computed: 
  {
    ...mapGetters(['company']),
   
  },
mounted()
    {   
      
        
    },
created()
{
   this.getData()
},    
methods: 
{ 
    openItem(index)
    {
      
      this.msg.title = ''
      for (let i = 0; i < this.isOpen.length; i++) {
        this.$set(this.isOpen,i,false)      
      }
      this.$set(this.isOpen,index,true) 
      
      
     
    },
    closeItems()
    {
      for (let i = 0; i < this.isOpen.length; i++) {
        this.$set(this.isOpen,i,false)      
      }
    },
    printTest()
    {
          this.refresh++
          this.$nextTick(() => {
           $('#printZebraModal').modal({keyboard: false,backdrop:'static','show':true});
      })
    },
    setData(labelId)
    {
      
      this.items = this.layout.filter(item => item.label_Id == labelId)
     /*
      this.isOpen.forEach(item =>{
        item = false
      })
     */
      
    },
    async getData()
    {
        const data     = {'companyId' : this.company.Id}
        const sp       = {'sp':'spCompanyLabels'}
        const json     = Object.assign(data, sp)

        await api.post(json).then(res => {
          if(res.status==200)
            {
              
            
              this.layout = res.data.recordsets[0]
              this.labels = res.data.recordsets[1]

              
           
                 
            }
            else if(res.status==500)
            {
              
              this.msg.title = 'ATTENZIONE '
              this.msg.body = res.data
              this.msg.type = 1                      
            } 
            else
            {
              
              this.msg.title = 'ATTENZIONE '
              this.msg.body = res
              this.msg.type = 1                      
            } 
        }).catch(err => 
        {
          

              this.msg.title = 'ATTENZIONE '
              this.msg.body = err.message
              this.msg.type = 1                      
          

        }).finally(() => {
          this.spinner = false
        });


        


    },
    
    updateData(item)
    {
        
        
        if(!item.zpl)            
        {
          return
        } 
        if(Number(item.skip) < 0 || Number(item.skip) > 1 )
        {
          return
        }
        if(Number(item.blank) < 0 || Number(item.blank) > 1)
        {
          return
        }
        if(Number(item.fmt) < 0 || Number(item.fmt) > 1)
        {
          return
        }
        if(Number(item.fd_len) < 0 )
        {
          return
        }

        const sp   = {'sp':'spUpdateLabelZpl'}
        
        const json = Object.assign(item, sp)    

        api.post(json).then(res => {
          if(res.status==200)
            {
                            
              
              this.msg.title = 'AGGIORNAMENTO EFFETTUATO.'
              this.msg.body = ''
              this.msg.type = 0   
              this.closeItems()

              
                                             
            }
            else if(res.status==500)
            {
              
              this.msg.title = 'ATTENZIONE '
              this.msg.body = res.data
              this.msg.type = 1                      
            } 
            else
            {
              
              this.msg.title = 'ATTENZIONE '
              this.msg.body = res
              this.msg.type = 1                      
            } 
        }).catch(err => 
        {
          

              this.msg.title = 'ATTENZIONE '
              this.msg.body = err.message
              this.msg.type = 1                      
          

        }).finally(() => {
          this.spinner = false
        });
  


    },

    
}    
  
}
</script>

<style scoped>
h4 {
  font-family: 'Roboto Condensed';
  font-size: 20px;
}
 .my-custom-scrollbar {
    position  : relative;
    height    : 400px;
    overflow  : auto;
    }
  .table-wrapper-scroll-y {
    display   : block;
  }

  .table thead tr:nth-child(1) th
 {

    font-family  : 'Roboto Condensed';
    font-size    : 16px;
    background   : hwb(45 4% 9%);  
    color        : black;
    position     : sticky;
    top          : 0;
    z-index      : 10;
  

 }
 .table-hover:hover
{
  cursor: pointer;
}

.bold{
  font-weight: bold;
}
td:nth-child(3) {
                width: 30%;
            }
</style>